export const PROJECT_SAMOLET = 'samolet'

export type ProjectMode = typeof PROJECT_SAMOLET

/**
 * Нормализует query-параметр `project`.
 * HR-ссылки приходят с `project=samolet`.
 */
export function resolveProjectMode(
  queryProject: string | string[] | undefined | null,
): ProjectMode | null {
  const value = typeof queryProject === 'string' ? queryProject.trim() : null

  if (value === PROJECT_SAMOLET) {
    return value
  }

  return null
}

/** Загружать ли данные через assistant-back / HURMA. */
export function isSamoletProjectMode(mode: ProjectMode | null): boolean {
  return mode === PROJECT_SAMOLET
}

/** Показывать ли поле телефона на prejoin. */
export function shouldShowPhoneField(mode: ProjectMode | null): boolean {
  return mode === PROJECT_SAMOLET
}

/** Нужно ли вызывать prejoin_check перед входом. */
export function shouldRunPrejoinCheck(mode: ProjectMode | null): boolean {
  return mode === PROJECT_SAMOLET || mode === null
}

/** Показывать ли блок инструкций Самолёта на prejoin. */
export function shouldShowSamoletInstructions(mode: ProjectMode | null, v: string | null): boolean {
  return mode === PROJECT_SAMOLET && v !== 'hr'
}

/** Показывать ли текст пользовательского соглашения Самолёта. */
export function shouldShowSamoletTerms(mode: ProjectMode | null): boolean {
  return mode === PROJECT_SAMOLET
}
